import { useHistory } from 'react-router-dom';
import { isCurrentIncludedPathInRoute, isCurrentRoute } from '../utils/navigation';
import { useCallback } from 'react';

export const usePolicyTemplatesGoBackUntilRoute = () => {
    const history = useHistory();

    const goBackUntilRoute = useCallback(
        (path: string) => {
            const removeListener = history.listen((location, action) => {
                if (action === 'POP') {
                    const isInExactRoute = isCurrentRoute(location.pathname, path);
                    const isInsideNestedRoute = isCurrentIncludedPathInRoute(location.pathname, path);

                    if (isInExactRoute || !isInsideNestedRoute) {
                        removeListener();
                        return;
                    }

                    history.goBack();
                }
            });

            history.goBack();
        },
        [history]
    );

    return { goBackUntilRoute };
};
